<template>
  <div
    v-if="breadcrumbList.length > 0"
    class="breadcrumb-wrapper"
    :class="!$route.path.startsWith('/adm') ? 'user' : ''"
  >
    <p
      v-if="
        !$route.path.startsWith('/adm') &&
        $route.path !== this.$filters.ctxPath('/main.page') &&
        $route.path !== this.$filters.ctxPath('/')
      "
      class="page-title"
    >
      {{ pageTitle }}
    </p>
    <div
      v-if="breadcrumbList.length > 0"
      class="breadcrumb-inner-wrap"
      :class="!$route.path.startsWith('/adm') ? 'user' : ''"
    >
      <div class="home">
        <router-link
          :to="{
            path: $route.path.startsWith('/adm') ? goToAdminHome : goToUserHome,
          }"
          ><span
            ><img :src="getThemeImageUrl('home_icon.svg')" alt="home-icon"
          /></span>
          홈
        </router-link>
        &gt;
      </div>
      <span
        v-for="(crumb, index) in breadcrumbList"
        :key="index"
        :class="{ 'last-crumb': index === breadcrumbList.length - 1 }"
      >
        {{ crumb.menuNm }}
        <span v-if="index < breadcrumbList.length - 1"> &gt; </span></span
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadcrumbList: [],
      goToAdminHome: this.$filters.ctxPath("/adm/main.page"),
      goToUserHome: this.$filters.ctxPath("/"),
      _breadcrumbPending: false,
    };
  },
  watch: {
    // 페이지 이동 시 동작
    $route: {
      immediate: true,
      handler() {
        this.debouncedGenerateBreadcrumb();
      },
    },
    // 새로고침 시 동작
    "$store.state.menuList": {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.debouncedGenerateBreadcrumb();
        }
      },
    },
    // store의 menu 변경 시 동작 (메뉴 클릭 후 setMenu 반영)
    "$store.state.menu": {
      handler(val) {
        if (val) {
          this.debouncedGenerateBreadcrumb();
        }
      },
    },
  },
  methods: {
    // nextTick 디바운스: $route와 menu가 거의 동시에 변경될 때 한 번만 실행
    debouncedGenerateBreadcrumb() {
      if (this._breadcrumbPending) return;
      this._breadcrumbPending = true;
      this.$nextTick(() => {
        this._breadcrumbPending = false;
        this.generateBreadcrumb();
      });
    },
    generateBreadcrumb() {
      const menuState = this.$store.state;
      const currentPath = this.$route.path;
      const basePath = currentPath.substring(0, currentPath.lastIndexOf("/")); // 현재 경로에서 마지막 '/' 이전까지의 경로
      // const pathType = currentPath.substring(currentPath.lastIndexOf('/') + 1);
      const upPath = basePath + "/list.page"; // 상위 경로(목록)로 생성
      const storeMenu = menuState.menu; // store에 이미 저장된 현재 메뉴 정보

      // 메뉴 리스트 펼치기
      const flattenMenus = (menus) => {
        const result = [];
        for (const menu of menus) {
          result.push(menu);
          if (menu.childList?.length) {
            result.push(...flattenMenus(menu.childList));
          }
        }
        return result;
      };

      // upMenuId를 따라 올라가며 브레드크럼 trail 구성
      const buildTrail = (flatMenus, currentMenu) => {
        const trail = [];
        let menu = currentMenu;
        while (menu) {
          const parent = flatMenus.find((m) => m.menuId === menu.upMenuId);
          if (parent) {
            trail.unshift(parent);
            menu = parent;
          } else {
            break;
          }
        }
        return trail;
      };

      // URL로 메뉴를 찾되, store의 menuId가 있으면 우선 매칭
      const findMenuByPath = (flatMenus, path) => {
        const candidates = flatMenus.filter((menu) => menu.routerUrl === path);
        if (candidates.length === 0) return null;
        // 같은 routerUrl이 여러 개면 store에 저장된 menuId와 일치하는 것 우선
        if (candidates.length > 1 && storeMenu?.menuId) {
          const exactMatch = candidates.find(
            (m) => m.menuId === storeMenu.menuId,
          );
          if (exactMatch) return exactMatch;
        }
        return candidates[0];
      };

      // 사용자: upMenuId 기반
      const findFromFlat = (flatMenus, path, isOwnPath) => {
        // 1순위: store에 저장된 menu가 있고, menuList에도 존재하면 그대로 사용
        if (storeMenu?.menuId) {
          const storeMenuInList = flatMenus.find(
            (m) => m.menuId === storeMenu.menuId,
          );
          if (storeMenuInList) {
            // store 메뉴의 routerUrl이 현재 경로와 일치하거나, 현재 경로의 상위 경로와 일치하면 사용
            if (
              storeMenuInList.routerUrl === path ||
              (!isOwnPath && storeMenuInList.routerUrl === upPath)
            ) {
              storeMenuInList.isOwnPath = isOwnPath;
              const trail = buildTrail(flatMenus, storeMenuInList);
              return [...trail, storeMenuInList];
            }
            // view/insert 등 하위 페이지에서 진입한 경우: store 메뉴의 routerUrl 경로 기반이 같으면 사용
            const storeMenuBasePath = storeMenuInList.routerUrl?.substring(
              0,
              storeMenuInList.routerUrl?.lastIndexOf("/"),
            );
            if (storeMenuBasePath && basePath === storeMenuBasePath) {
              storeMenuInList.isOwnPath = isOwnPath;
              const trail = buildTrail(flatMenus, storeMenuInList);
              return [...trail, storeMenuInList];
            }
          }
        }

        // 2순위: URL 기반 fallback (새로고침/직접 URL 입력 시)
        const findCurrent = findMenuByPath(flatMenus, path);
        if (!findCurrent) return [];

        findCurrent.isOwnPath = isOwnPath;
        this.$store.commit("setMenu", findCurrent);

        const trail = buildTrail(flatMenus, findCurrent);
        return [...trail, findCurrent];
      };

      // 관리자: childList 기반
      const findFromTree = (menus, path, trail = [], isOwnPath) => {
        for (const menu of menus) {
          const newTrail = [...trail, menu];
          if (menu.routerUrl === path) {
            menu.isOwnPath = isOwnPath; // 본인 경로 여부
            this.$store.commit("setMenu", menu);
            return newTrail;
          }
          if (menu.childList?.length) {
            const found = findFromTree(menu.childList, path, newTrail);
            if (found) return found;
          }
        }
        return null;
      };

      // // 사용자: upMenuId 기반
      // const findFromFlat = (flatMenus, path, isOwnPath) => {
      // 	const findCurrent = flatMenus.find(menu => menu.routerUrl === path);
      // 	if (!findCurrent) return [];

      // 	findCurrent.isOwnPath = isOwnPath; // 본인 경로 여부
      // 	this.$store.commit('setMenu', findCurrent);

      // 	const buildTrail = (menu, trail = []) => {
      // 		const parent = flatMenus.find(m => m.menuId === menu.upMenuId);
      // 		if (parent) {
      // 			return buildTrail(parent, [parent, ...trail]);
      // 		}
      // 		return trail;
      // 	};

      // 	const trail = buildTrail(findCurrent);
      // 	return [...trail, findCurrent];
      // };

      // // 메뉴 리스트 펼치기
      // const flattenMenus = (menus) => {
      // 	const result = [];

      // 	for (const menu of menus) {
      // 		result.push(menu);
      // 		if (menu.childList?.length) {
      // 			result.push(...flattenMenus(menu.childList));
      // 		}
      // 	}

      // 	return result;
      // }

      let breadcrumb = [];

      // 구조 판단
      if (menuState.menuList?.length) {
        // 사용자용
        // const flatMenus = menuState.menuList.flatMap(menu =>
        //   [menu, ...(menu.childList || [])]
        // );
        const flatMenus = flattenMenus(menuState.menuList);
        const matchMenu = flatMenus.find(
          (menu) => menu.routerUrl === currentPath,
        );
        let path = currentPath;
        let isOwnPath = true; // 본인 경로임
        if (!matchMenu) {
          path = upPath; // 현재 경로가 메뉴에 없다면 상위 경로 사용
          isOwnPath = false; // 본인 경로가 아님
        }

        breadcrumb = findFromFlat(flatMenus, path, isOwnPath);
      } else if (menuState.menu?.childList?.length) {
        // 관리자용
        const flatMenus = flattenMenus(menuState.menuList || []);
        const matchMenu = flatMenus.find(
          (menu) => menu.routerUrl === currentPath,
        );
        let path = currentPath;
        let isOwnPath = true;
        if (!matchMenu) {
          path = upPath;
          isOwnPath = false;
        }
        breadcrumb = findFromTree(
          menuState.menu.childList,
          path,
          [],
          isOwnPath,
        );
      }

      this.breadcrumbList = breadcrumb;
    },
  },
  mounted() {
    // this.generateBreadcrumb();
  },
  computed: {
    pageTitle() {
      return this.breadcrumbList.at(-1)?.menuNm || "";
    },
  },
};
</script>
